<template>
  <div
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <div class="tabs-container">
      <el-tabs v-if="showView" v-model="activeTabName" type="card" style="width:100%;height: 100%">
        <el-tab-pane v-if="singleReleaseVerifyView" :lazy="true" :label="$t('CargoMsg.Cargo_BLReleaseReview')" name="singleReleaseVerifyView" style="width:100%;height: 100%">
          <single-release-verify-view
            tab-name="singleReleaseVerifyView"
            :tab-title="$t('CargoMsg.Cargo_BLReleaseReview')"
          />
        </el-tab-pane>
        <el-tab-pane v-if="singleReleaseView" :lazy="true" :label="$t('CargoMsg.Cargo_BLControl')" name="singleReleaseView" style="width:100%;height: 100%">
          <single-release-view
            tab-name="singleReleaseView"
            :tab-title="$t('CargoMsg.Cargo_BLControl')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ReleaseHbl')" name="hblSingleReleaseVerifyBaseView" style="width:100%;height: 100%">
          <hbl-single-release-verify-base-view
            tab-name="hblSingleReleaseVerifyBaseView"
            :tab-title="$t('CargoMsg.Cargo_ReleaseHbl')"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import singleReleaseVerifyView from '@/views/cargo/v0/Clearing/components/releaseControl/singleReleaseVerifyView'
import singleReleaseView from '@/views/cargo/v0/Clearing/components/releaseControl/singleReleaseView'
import HblSingleReleaseVerifyBaseView
  from '@/views/cargo/v0/Clearing/components/releaseControl/hblSingleReleaseVerifyBaseView'
import checkPermission from '@/utils/permission'

export default {
  name: 'FmSingleRelease',
  components: { HblSingleReleaseVerifyBaseView, singleReleaseVerifyView, singleReleaseView },
  data() {
    return {
      loading: true,
      activeTabName: 'singleReleaseVerifyView',
      singleReleaseVerifyView: false,
      singleReleaseView: false,
      showView: true
    }
  },
  async created() {
    this.loading = false
    this.singleReleaseVerifyView = checkPermission(['tab_SingleRelease_tabSingleReleaseVerify'])
    this.singleReleaseView = checkPermission(['tab_SingleRelease_tabSingleRelease'])
    if (this.singleReleaseVerifyView) {
      this.activeTabName = 'singleReleaseVerifyView'
    } else if (this.singleReleaseView) {
      this.activeTabName = 'singleReleaseView'
    } else {
      this.activeTabName = 'hblSingleReleaseVerifyBaseView'
    }
    this.showView = !(!this.singleReleaseVerifyView && !this.singleReleaseView)
  }
}
</script>
